var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableCell = void 0;
var TableCell_1 = __importDefault(require("./TableCell"));
exports.TableCell = TableCell_1.default;
exports.default = TableCell_1.default;
//# sourceMappingURL=index.js.map